import type { ReactNode } from "react";
import { tw } from "../../styling/helpers";
import { gaps } from "../../styling/theme";

type Props = {
	children: ReactNode;
	cols?: 1 | 2 | 3 | 4 | 6;
	gap?: 0 | 1 | 2 | 4 | 6 | 8;
};

const columnClasses = tw`grid w-full grid-cols-1`;

const variants = {
	1: tw`grid-cols-1`,
	2: tw`tablet:grid-cols-2`,
	3: tw`tablet:grid-cols-2 laptop:grid-cols-3`,
	4: tw`tablet:grid-cols-4`,
	6: tw`tablet:grid-cols-6`,
};

export const SimpleGrid = ({ children, cols = 1, gap = 4 }: Props) => (
	<div className={tw(columnClasses, variants[cols], gaps[gap])}>{children}</div>
);
